import {
  useCreateValidPackagesFromImported,
  usePackagesImportedInfiniteQuery,
} from "../hooks/usePackages";
import { EnhancedPackagesImportedList } from "./EnhancedPackagesImportedList";
import { Button } from "@shared/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@shared/components/ui/card";
import ThreeDotLoader from '@shared/components/ThreeDotLoader';
import { RefreshCw, CheckCircle2, Package } from "lucide-react";
import { useTranslation } from "react-i18next";

const ImportedPackages = () => {
  const { t } = useTranslation();
  const params = {
    limit: 40,
  };
  const { data, isLoading, refetch } = usePackagesImportedInfiniteQuery(params);

  const { isPending, mutate: createAllValid } =
    useCreateValidPackagesFromImported();

  const handleCreateAllValid = async () => {
    createAllValid();
  };

  if (isLoading)
    return (
      <div className="flex justify-center mt-8">
        <ThreeDotLoader />
      </div>
    );

  return (
    <Card className="w-full">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Package className="h-5 w-5" />
          {t("packages.importedPackages")}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex justify-end items-center mb-4 gap-3">
          <Button
            variant="outline"
            onClick={refetch}
            className="flex items-center gap-2"
          >
            <RefreshCw className="h-4 w-4" />
            {t("common.refresh")}
          </Button>
          <Button
            onClick={handleCreateAllValid}
            disabled={isPending}
            className="flex items-center gap-2"
          >
            <CheckCircle2 className="h-4 w-4" />
            {isPending
              ? t("packages.creatingValid")
              : t("packages.createAllValid")}
          </Button>
        </div>
        {data?.pages[0]?.data && (
          <EnhancedPackagesImportedList
            initialOrders={data.pages[0].data}
            useEnhancedView={true}
            onBulkAction={(action, packages) => {
              console.log(`Bulk ${action} for packages:`, packages);
              // Handle bulk actions here
            }}
          />
        )}
      </CardContent>
    </Card>
  );
};

export default ImportedPackages;
